module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAeklEQVQYV3WOsQmDUABE35Up09s7gTiBRUYwIwRSZBUbN3AHCWQFwU5whkDaNBf+5xs+wVx33DvuZHsAWv7rDpxk+wjMQLHDLkAt6aUQ2m6AEYg+6ZmgNfhvYLsDrgl6xznpsbVy8ABMQAlcJPX5lXwqXKiAs6Tb798PyO0gB3RQIPYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/low.png
// module id = yCic
// module chunks = 45